import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { HotelSearchedRoomRate, HotelSearchedRoom } from '@hotels/hotel-results/entities/hotel-searched';
import { BreakfastNotIncluded } from '@hotels/hotel-detail/entities/hotel-detail.response';
import { RefundableType } from '@hotels/hotel-detail/entities/hotel-detail.response';
import { TagType } from '@ux/components/member-rate-tag/entities/tag-type';
import { getHotelTagType } from '@ux/components/member-rate-tag/mappers/tag.mapper';
import { ProductTags } from '@app/constants/product-tags.constants';
import { ButtonSize } from '@design-system/components/molecules/button/entities/button.types';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';

export interface RoomEvent {
  room: string;
  checkInHour?: string;
  capacity?: number;
}

@Component({
  selector: 'app-hotel-room-price',
  templateUrl: './hotel-room-price.component.html',
  styleUrls: ['./hotel-room-price.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HotelRoomPriceComponent {

  @Input() roomRate: HotelSearchedRoomRate;
  @Input() room: HotelSearchedRoom;
  @Input() nights: number;
  @Input() numberRooms: number;
  @Input() isMobile: boolean;
  @Input() isPackageDetail: string;
  @Input() hasRappiCard: boolean;
  @Input() isPrime: boolean;
  @Input() isLoggedIn: boolean;
  @Input() classTag: ProductTags;
  @Input() provider: string;
  @Input() isByhours: boolean;
  @Input() hourType: number;
  @Input() isLoading = false;

  @Output() selectRoom: EventEmitter<RoomEvent> = new EventEmitter<RoomEvent>();

  public showHoursSwipe = false;
  public selectedTime: string;
  
  public readonly buttonSize = ButtonSize.SM;

  public readonly icons = Icon;
  public readonly iconFillColor = IconFillColor;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  constructor(
    private translateService: TranslocoService,
  ) { }

  get isOneNight(): boolean {
    return !!this.nights && this.nights === 1;
  }

  get boardRoomDescription(): string {
    return this.room?.BoardDescription ? this.room.BoardDescription :
      this.translateService.translate('HOTELS_MODULE.DETAIL_DESCRIPTION.ONLY_ROOM');
  }

  get boardIcon(): Icon {
    return this.room?.BoardDescription ? Icon.Restaurant : Icon.Bed;
  }

  get capacity(): number {
    return this.roomRate?.Capacity;
  }

  get tagType(): TagType {
    return getHotelTagType(
      this.roomRate?.MemberRateIndicator,
      this.classTag, this.hasRappiCard, this.isPrime, this.isLoggedIn, this.provider
    );
  }

  public breakfastIncluded(boardCode: string): boolean {
    return !BreakfastNotIncluded.includes(boardCode);
  }

  public isRefundable(refundableType: string): boolean {
    return refundableType !== RefundableType.NonRefundable;
  }

  public clickEvent(room: string): void {
    if (this.isByhours) {
      this.toogleShowHours();
    } else {
      this.selectRoom.emit({ room });
    }
  }

  public validateAndSetHour(): void {
    if (this.roomRate.CheckinTimes.length > 0) {
      this.selectedTime = this.roomRate.CheckinTimes[0];
    }
  }

  public toogleShowHours(): void {
    this.showHoursSwipe = !this.showHoursSwipe;
    this.validateAndSetHour();
  }

  public selectTime(time: string): void {
    this.selectedTime = time;
  }

  public applyTime(room: string): void {
    this.selectRoom.emit({ room, checkInHour: this.selectedTime?.replace(':', ''), capacity: this.capacity});
  }

}
